import { astarInterface } from '../../astar/astarInterface-sidecar'
import { EVoyageTile } from './voyageTileData'
import { voyageTilemap } from './voyageTilemap-sidecar'
import type { IVoyageTilemapPart } from './voyageTilemapPart'

const hash = (node: IVoyageTilemapPart) => {
  return node.i + ':' + node.j
}

const canMoveOnBreach = false
const canMoveOnFire = false

export const findPath = (
  start: IVoyageTilemapPart,
  end: IVoyageTilemapPart,
  // allowNextTo: boolean,
) => {
  // if (allowNextTo) {
  //   assert.
  //   // return findPathAny(grid, start, [end])
  // }

  return findPathAny(start, [end])
}

export const findPathAny = (
  start: IVoyageTilemapPart,
  ends: IVoyageTilemapPart[],
) => {
  let isOne = ends.length === 1
  let endOne = ends[0]

  const heightPenalty = 1
  const elevatorPenalty = 5

  const distance = (a: IVoyageTilemapPart, b: IVoyageTilemapPart) => {
    let dx = Math.abs(a.i - b.i)
    let dy = Math.abs(a.j - b.j)
    let h = dx + dy * heightPenalty
    return h
  }
  const heuristicOne = (node: IVoyageTilemapPart) => {
    let end = endOne
    let dx = Math.abs(node.i - end.i)
    let dy = Math.abs(node.j - end.j)
    let h = dx + dy * heightPenalty
    h += node.tile3.pathfindPenalty
    return h
  }
  const heuristicAny = (node: IVoyageTilemapPart) => {
    // Find minimum distance
    let hMin = Number.MAX_SAFE_INTEGER
    for (let i = 0; i < ends.length; i++) {
      let end = ends[i]
      let dx = Math.abs(node.i - end.i)
      let dy = Math.abs(node.j - end.j)
      let h = dx + dy * heightPenalty
      h += node.tile3.pathfindPenalty
      if (h < hMin) {
        hMin = h
      }
    }
    return hMin
  }

  const checkNeighbor = (
    node: IVoyageTilemapPart,
    oi: number,
    oj: number,
    neighbors: IVoyageTilemapPart[],
  ) => {
    let tn = voyageTilemap.getSafe(node.i + oi, node.j + oj)

    if (tn) {
      if (tn.tile2.canWalk) {
        let skip = false

        if (tn.breach && !canMoveOnBreach) {
          skip = true
        }
        if (tn.fire && !canMoveOnFire) {
          skip = true
        }

        if (tn.crew.length > 0) {
          skip = true
        }

        // Can only go down on ladders
        // if (!skip && oj === 1) {
        //   if (tn.type !== TypeLadder) {
        //     skip = true
        //   }
        // }

        if (!skip) {
          neighbors.push(tn)
        }
      }
    }
  }

  const neighbor = (node: IVoyageTilemapPart) => {
    if (!node.tile2.canWalk) {
      return [] // Can't move here
    }

    // left, right, up, down, traverse plane
    let neighbors: IVoyageTilemapPart[] = []
    checkNeighbor(node, -1, 0, neighbors)
    checkNeighbor(node, 1, 0, neighbors)
    checkNeighbor(node, 0, -1, neighbors)
    checkNeighbor(node, 0, 1, neighbors)

    if (node.tile3.type === EVoyageTile.Elevator) {
      let els = voyageTilemap.getElevators(node.text3)
      for (let i = 0; i < els.length; i++) {
        let el = els[i]
        if (el !== node) {
          neighbors.push(el)
        }
      }
    }

    // TODO: if elevator
    // if (node.type === TypeLadder) {
    //   // Can go up on ladders
    //   checkNeighbor(0, -1)
    // }

    return neighbors
  }

  const isEndOne = (node: IVoyageTilemapPart) => {
    return node.i === endOne.i && node.j === endOne.j
  }
  const isEndAny = (node: IVoyageTilemapPart) => {
    for (let i = 0; i < ends.length; i++) {
      let end = ends[i]
      if (node.i === end.i && node.j === end.j) {
        return true
      }
    }
    return false
  }

  let t0 = performance.now()
  let result = astarInterface.findPath<IVoyageTilemapPart>({
    start,
    isEnd: isOne ? isEndOne : isEndAny,
    neighbor,
    distance,
    heuristic: isOne ? heuristicOne : heuristicAny,
    hash,
    timeout: 5000,
  })

  if (result.status === 'noPath') {
    result.path = [] // Clear path
  }

  let t1 = performance.now()
  let timeElapsed = t1 - t0
  if (timeElapsed > 10 || result.status !== 'success') {
    console.log(
      'astar',
      'path result',
      result.status,
      result.path.length,
      timeElapsed.toFixed(1),
      'ms',
    )
  }
  return result
}
